<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="billing/tariffs/list"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">Тарифы</h2>
        <btn-action class="btn btn-primary" @click="tariffNewModalOpen()">Создать тариф</btn-action>
      </div>
    </div> 
    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column prop="name" label="Тариф" align="center"/>
        <el-table-column prop="code" label="Код" align="center"/>
        <el-table-column prop="price" label="Цена за модем" align="center"/>
        <el-table-column prop="mobile_access" label="Мобильный доступ" align="center"/>
        <el-table-column prop="active" label="Активность" align="center"/>
        <el-table-column prop="visible" label="Отображение" align="center"/>
        <el-table-column prop="order" label="Порядок" align="center"/>
        <el-table-column label="Редактировать" width="180" align="center">
          <template slot-scope="{row}" v-if="row.code !== 'test' && row.code !== 'terminated'">
            <button class="btn btn-sm btn-outline-light" @click="tariffEditModalOpen(row)">Редактировать</button>
          </template>
        </el-table-column>
        <el-table-column label="Удалить" width="180" align="center">
          <template slot-scope="{row}" v-if="row.code !== 'test' && row.code !== 'terminated' && row.code !== 'basic' && row.code !== 'optimal' && row.code !== 'maximal'">
            <button class="btn btn-sm btn-outline-light" @click="tariffRemoveModalOpen(row)">Удалить</button>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'
  import tariffEditModal from '../../../components/billing/modals/tariff-edit.vue'
  import tariffRemoveModal from '../../../components/billing/modals/tariff-remove.vue'

  export default {
    metaInfo: {title: 'Тарифы'},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
        filtersValue: null,
      }
    },
    methods: {
      tariffNewModalOpen () { 
        this.$root.showModal(tariffEditModal, {}).then((data) => {
          if (data && data.refresh) {
            this.refresh = false
          }
        })
      },
      tariffEditModalOpen (row) { 
        this.$root.showModal(tariffEditModal, {
          id: row.id,
          tariff: row,
        }).then((data) => {
          if (data && data.refresh) {
            this.refresh = false
          }
        })
      },
      tariffRemoveModalOpen (row) { 
        this.$root.showModal(tariffRemoveModal, {
          id: row.id,
          tariff: row,
        }).then((data) => {
          if (data && data.refresh) {
            this.refresh = false
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
tbody tr{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/organizations/tariffs.vue